import { NotificationConstants } from './notificationConstants';
import _ from 'lodash';

// set template delimiter
_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;

const NotificationTitles = {
  // 巡回記録
  safetyDiariesPointedOut: '指摘事項',
  safetyDiariesInform: '周知事項',
  safetyDiariesRecovery: '指摘事項の是正報告',
  safetyDiariesRecoveryApproved: '指摘事項の承認',
  safetyDiariesRecoveryRejected: '指摘事項の否認',
  safetyDiariesRecoveryDropped: '指摘事項の承認',
  safetyDiariesWorkCommunication: '当日作業連絡',
  // 調整会議
  // 現場
  fieldCreated: '新規現場登録',
  fieldCreateRequest: '新規現場登録の承認依頼',
  fieldCreateApproved: '新規現場登録の承認',
  fieldCreateRejected: '新規現場登録の否認',
  // 会社情報の更新
  companyInformationUpdated: '会社情報更新',
  companyBranchInformationUpdated: '支店情報更新',
  partnerCompanyInformationupdated: '会社情報更新',
  // アカウント更新
  accountUpdated: 'アカウントの更新',
  // 施工体系図
  fieldTreeLinked: '現場招待',
  fieldTreeUnlinked: '現場紐付き解除',
  fieldTreeRequest: '施工体制の承認依頼',
  fieldTreeApproved: '施工体制の承認',
  fieldTreeRejected: '施工体制の否認',
  fieldTreeRemoved: '現場紐付き解除',
  fieldTreeWorkCompleted: '現場作業の完了',
  fieldTreeWorkResumed: '現場作業の再開',
  // 作業予定/実績
  workSchduleCreated: '作業予定登録',
  workResultCreated: '作業実績登録',
  // ゲート予定
  gatePassagesCreated: 'ゲート予定登録',
  gatePassagesUpdated: 'ゲート予定更新',
  craneUses: '',
  machineryUses: '',
};

const Roles = {
  Prime: '本社管理者',
  Branch: '支店管理者',
  Manager: '現場監督',
  Foreman: '職長',
};

const createSafetyDiariesPointedOutTemplate = userRole =>
  _.template(
    `${userRole}:{{from_user_name}}さんより指摘事項が届いています。是正を行ってください。`
  );

const createSafetyDiariesRecoveryTemplate = userRole =>
  _.template(
    `${userRole}:{{from_user_name}}さんより是正報告が届いています。承認作業を行ってください。`
  );

const createSafetyDiariesRecoveryApprovedTemplate = userRole =>
  _.template(`${userRole}:{{from_user_name}}さんにより是正承認されました。`);

const createSafetyDiariesRecoveryRejectedTemplate = userRole =>
  _.template(`${userRole}:{{from_user_name}}さんにより是正が否認されました。`);

// eslint-disable-next-line no-unused-vars
const createSafetyDiariesDroppedTemplate = userRole =>
  _.template(`${userRole}:{{from_user_name}}さんにより是正承認されました。`);

const createSafetyDiariesInformTemplate = userRole =>
  _.template(`${userRole}:{{from_user_name}}さんより周知事項が届いています。`);

const createSafetyDiariesWorkCommunicationTemplate = userRole =>
  _.template(
    `${userRole}:{{from_user_name}}さんより当日作業連絡が届いています。`
  );

const NotificationMessages = {
  // 巡回記録(指摘)
  [NotificationConstants.safetyDiariesPointedOutFromBranch.messageTypeId]: {
    title: NotificationTitles.safetyDiariesPointedOut,
    contentTemplate: createSafetyDiariesPointedOutTemplate(Roles.Branch),
  },
  [NotificationConstants.safetyDiariesPointedOutFromForeman.messageTypeId]: {
    title: NotificationTitles.safetyDiariesPointedOut,
    contentTemplate: createSafetyDiariesPointedOutTemplate(Roles.Foreman),
  },
  [NotificationConstants.safetyDiariesPointedOutFromManager.messageTypeId]: {
    title: NotificationTitles.safetyDiariesPointedOut,
    contentTemplate: createSafetyDiariesPointedOutTemplate(Roles.Manager),
  },
  [NotificationConstants.safetyDiariesPointedOutFromPrime.messageTypeId]: {
    title: NotificationTitles.safetyDiariesPointedOut,
    contentTemplate: createSafetyDiariesPointedOutTemplate(Roles.Prime),
  },
  // 巡回記録(是正報告)
  [NotificationConstants.safetyDiariesRecoveryFromBranch.messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecovery,
    contentTemplate: createSafetyDiariesRecoveryTemplate(Roles.Branch),
  },
  [NotificationConstants.safetyDiariesRecoveryFromForeman.messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecovery,
    contentTemplate: createSafetyDiariesRecoveryTemplate(Roles.Foreman),
  },
  [NotificationConstants.safetyDiariesRecoveryFromManager.messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecovery,
    contentTemplate: createSafetyDiariesRecoveryTemplate(Roles.Manager),
  },
  [NotificationConstants.safetyDiariesRecoveryFromPrime.messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecovery,
    contentTemplate: createSafetyDiariesRecoveryTemplate(Roles.Prime),
  },
  // 巡回記録(是正承認)
  [NotificationConstants.safetyDiariesRecoveryApprovedFromBranch
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryApproved,
    contentTemplate: createSafetyDiariesRecoveryApprovedTemplate(Roles.Branch),
  },
  [NotificationConstants.safetyDiariesRecoveryApprovedFromForeman
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryApproved,
    contentTemplate: createSafetyDiariesRecoveryApprovedTemplate(Roles.Foreman),
  },
  [NotificationConstants.safetyDiariesRecoveryApprovedFromManager
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryApproved,
    contentTemplate: createSafetyDiariesRecoveryApprovedTemplate(Roles.Manager),
  },
  [NotificationConstants.safetyDiariesRecoveryApprovedFromPrime
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryApproved,
    contentTemplate: createSafetyDiariesRecoveryApprovedTemplate(Roles.Prime),
  },
  // 巡回記録(是正否認)
  [NotificationConstants.safetyDiariesRecoveryRejectedFromBranch
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryRejected,
    contentTemplate: createSafetyDiariesRecoveryRejectedTemplate(Roles.Branch),
  },
  [NotificationConstants.safetyDiariesRecoveryRejectedFromForeman
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryRejected,
    contentTemplate: createSafetyDiariesRecoveryRejectedTemplate(Roles.Foreman),
  },
  [NotificationConstants.safetyDiariesRecoveryRejectedFromManager
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryRejected,
    contentTemplate: createSafetyDiariesRecoveryRejectedTemplate(Roles.Manager),
  },
  [NotificationConstants.safetyDiariesRecoveryRejectedFromPrime
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesRecoveryRejected,
    contentTemplate: createSafetyDiariesRecoveryRejectedTemplate(Roles.Prime),
  },
  // 巡回記録(取り下げ/未定義)
  // [NotificationConstants.safetyDiariesDroppedFromBranch.messageTypeId]:{
  //   title:NotificationTitles.safetyDiariesDropped,
  //   contentTemplate:createSafetyDiariesDroppedTemplate(Roles.Branch),
  // },
  // [NotificationConstants.safetyDiariesDroppedFromForeman.messageTypeId]:{
  //   title:NotificationTitles.safetyDiariesDropped,
  //   contentTemplate:createSafetyDiariesDroppedTemplate(Roles.Foreman),
  // },
  // [NotificationConstants.safetyDiariesDroppedFromManager.messageTypeId]:{
  //   title:NotificationTitles.safetyDiariesDropped,
  //   contentTemplate:createSafetyDiariesDroppedTemplate(Roles.Manager),
  // },
  // [NotificationConstants.safetyDiariesDroppedFromPrime.messageTypeId]:{
  //   title:NotificationTitles.safetyDiariesDropped,
  //   contentTemplate:createSafetyDiariesDroppedTemplate(Roles.Prime),
  // },
  // 巡回記録(周知)
  [NotificationConstants.safetyDiariesInformFromBranch.messageTypeId]: {
    title: NotificationTitles.safetyDiariesInform,
    contentTemplate: createSafetyDiariesInformTemplate(Roles.Manager),
  },
  [NotificationConstants.safetyDiariesInformFromForeman.messageTypeId]: {
    title: NotificationTitles.safetyDiariesInform,
    contentTemplate: createSafetyDiariesInformTemplate(Roles.Foreman),
  },
  [NotificationConstants.safetyDiariesInformFromManager.messageTypeId]: {
    title: NotificationTitles.safetyDiariesInform,
    contentTemplate: createSafetyDiariesInformTemplate(Roles.Manager),
  },
  [NotificationConstants.safetyDiariesInformFromPrime.messageTypeId]: {
    title: NotificationTitles.safetyDiariesInform,
    contentTemplate: createSafetyDiariesInformTemplate(Roles.Prime),
  },
  // 巡回記録(作業連絡) createSafetyDiariesWorkCommunicationTemplate
  [NotificationConstants.safetyDiariesWorkCommunicationFromBranch
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesWorkCommunication,
    contentTemplate: createSafetyDiariesWorkCommunicationTemplate(
      Roles.Manager
    ),
  },
  [NotificationConstants.safetyDiariesWorkCommunicationFromForeman
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesWorkCommunication,
    contentTemplate: createSafetyDiariesWorkCommunicationTemplate(
      Roles.Foreman
    ),
  },
  [NotificationConstants.safetyDiariesWorkCommunicationFromManager
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesWorkCommunication,
    contentTemplate: createSafetyDiariesWorkCommunicationTemplate(
      Roles.Manager
    ),
  },
  [NotificationConstants.safetyDiariesWorkCommunicationFromPrime
    .messageTypeId]: {
    title: NotificationTitles.safetyDiariesWorkCommunication,
    contentTemplate: createSafetyDiariesWorkCommunicationTemplate(Roles.Prime),
  },
  // 現場作成
  [NotificationConstants.fieldUpdatedFromBranch.messageTypeId]: {
    title: NotificationTitles.fieldCreated,
    contentTemplate: _.template(
      '新規現場（{{to_field_name}}）が登録されました。'
    ),
  },
  [NotificationConstants.fieldUpdatedFromManager.messageTypeId]: {
    title: NotificationTitles.fieldCreated,
    contentTemplate: _.template(
      '新規現場（{{to_field_name}}）が登録されました。'
    ),
  },
  [NotificationConstants.fieldUpdatedFromPrime.messageTypeId]: {
    title: NotificationTitles.fieldCreated,
    contentTemplate: _.template(
      '新規現場（{{to_field_name}}）が登録されました。'
    ),
  },
  // 現場作成承認依頼
  [NotificationConstants.masterFieldCreatedRequest.messageTypeId]: {
    contentTemplate: _.template(
      '{{user_role}}:{{from_user_name}}さんより新規現場（{{to_field_name}}）が申請されました。承認作業を行ってください。'
    ),
  },
  // 作業予定登録
  [NotificationConstants.conferenceWorkPlansCreatedNotification
    .messageTypeId]: {
    title: NotificationTitles.workSchduleCreated,
  },
  // 作業実績登録
  [NotificationConstants.conferenceWorkResultsCreatedNotification
    .messageTypeId]: {
    title: NotificationTitles.workResultCreated,
  },
  // ゲート予定登録
  [NotificationConstants.conferenceGatePlansCreatedNotification
    .messageTypeId]: {
    title: NotificationTitles.gatePassagesCreated,
  },
  // ゲート予定編集
  [NotificationConstants.conferenceGatePlansUpdatedNotification
    .messageTypeId]: {
    title: NotificationTitles.gatePassagesUpdated,
  },
};

export default NotificationMessages;



// WEBPACK FOOTER //
// ./src/utilities/notificationMessages.js